import React from 'react';
import { Navigate } from 'react-router-dom';
import { STORAGE_KEYS } from 'utils/constants';
import { getTeamRoles } from 'utils/role-config';
import useRoleContext from 'contexts/role.context';

const UnauthRoute = ({ children }: { children: JSX.Element }) => {
  const teamRoutes = getTeamRoles();
  const { role } = useRoleContext();
  const fallback = role ? teamRoutes?.[role]?.baseRoute ?? '' : '';
  const token: any = localStorage.getItem(STORAGE_KEYS.TOKEN);

  return !token ? children : <Navigate to={fallback} />;
};
export default UnauthRoute;
